module.exports = __webpack_public_path__ + "static/media/vail-15.bb28fa10.jpg";